import React from 'react';
import { Link } from 'react-router-dom';
import { AddToArtifactIcon, ConsoleIcon, DiagramTreeIcon, EditIcon, IconButton, Menu, MoreIcon, Popover, Position, RemoveIcon } from 'evergreen-ui';
import { DEVICES, DEVICE_DETECTOR, NEW, SEND_MESSAGE, TERMINAL } from 'Features/routePaths';
import { DialogDatasourceDelete } from './DialogDatasourceDelete';
import { ExtendedDatasourceProps, getStationDatasourcePath, isHydropad } from './utils';

type DatasourceMenuProps = ExtendedDatasourceProps & {
  stationId: number,
  isStationAdmin: boolean,
}

/** Меню источника. Отображается, если пользователь админ станции */
export function DatasourceMenu({ stationId, datasource, isStationAdmin }:DatasourceMenuProps) {
  const [isShownDelete, setIsShownDelete] = React.useState(false);
  const deleteDatasource = () => setIsShownDelete(true);

  if (!isStationAdmin) return null;
  return (
    <>
      <DialogDatasourceDelete
        datasource={datasource}
        isShown={isShownDelete}
        onClose={setIsShownDelete}
      />
      <Popover
        position={Position.BOTTOM_RIGHT}
        content={({ close }) => DatasourcePopoverContentMenu({ close, stationId, datasource, deleteDatasource })}
      >
        <IconButton
          icon={MoreIcon}
          appearance="minimal"
        />
      </Popover>
    </>
  );
}
export const MemoDatasourceMenu = React.memo(DatasourceMenu);
MemoDatasourceMenu.displayName = 'MemoDatasourceMenu';
export default DatasourceMenu;

/**
 * Меню к `DatasourceMenu`
 */
// note: так как это скрывающаяся часть в портале, то ничего не мемоизирую (не имеет смысла)
function DatasourcePopoverContentMenu(
  { close, stationId, datasource, deleteDatasource }:
  ExtendedDatasourceProps & { stationId: number, deleteDatasource: () => void, close: () => void, },
) {
  const toStationDatasourcePath = stationId
    ? `${getStationDatasourcePath({ stationId, datasourceId: datasource.id })}/`
    : undefined;

  const isHydropadType = isHydropad(datasource.datasourceTypeShortName);

  const menu = [
    {
      to: '',
      name: 'Редактировать источник данных',
      icon: EditIcon,
    },
    {
      to: `${DEVICES}/${DEVICE_DETECTOR}/${NEW}`,
      name: 'Добавить датчик',
      icon: DiagramTreeIcon,
      isInvisible: isHydropadType,
    },
    {
      isDivider: true,
    },
    {
      to: SEND_MESSAGE,
      name: 'Отправить сообщение',
      icon: AddToArtifactIcon,
      isInvisible: !isHydropadType,
    },
    {
      isDivider: true,
      isInvisible: !isHydropadType,
    },
    {
      to: TERMINAL,
      name: 'Терминал',
      icon: ConsoleIcon,
    },
  ];

  const onSelectDeleteDatasource = () => {
    deleteDatasource();
    close();
  };
  return (
    <Menu>
      <Menu.Group>
        {
        menu.map(({ to, icon, name, isInvisible, isDivider }) => {
          const toPath = `${toStationDatasourcePath}/${to}`;
          if (isInvisible) return null;
          if (isDivider) return <Menu.Divider key={toPath} />;
          return (
            <Menu.Item
              key={toPath}
              is={Link}
              to={toPath}
              icon={icon}
              onSelect={close}
            >
              {`${name}`}
            </Menu.Item>
          );
        })
      }

        <Menu.Divider />

        <Menu.Item
          onSelect={onSelectDeleteDatasource}
          icon={RemoveIcon}
          intent="danger"
        >
          Удалить источник данных
        </Menu.Item>
      </Menu.Group>
    </Menu>
  );
}
